/* ProductTileSwatches is a custom element for Donna Karan */
/* (Not part of original Maker theme) */
class ProductTileSwatches extends HTMLElement {
  constructor () {
    super()
  }
  connectedCallback () {
    //window.console.log('ProductTileSwatches connectedCallback');
    this.productTile = this.closest('.product--root');
    this.productTileHref = this.productTile.querySelector('.product-tile--link').getAttribute('href');
    this.masterSku = this.productTile.getAttribute('data-master-sku');
    //window.console.log('ProductTileSwatches masterSku', this.masterSku);
    this.updateViewListener();

  }
  disconnectedCallback () {
    //window.console.log('ProductTileSwatches disconnectedCallback')
  }
  updateViewListener () {
    window.on(`theme:producttile:${this.masterSku}:variantsLoaded`,
      ({ detail: { products: t } }) => {
        //console.log('handling variantsLoaded', this.masterSku);
        this.updateSwatches(t);
      }
    );
  }
  updateSwatches(products) {
    var productTileHref = this.productTileHref;
    var radiosRoot = this.querySelectorAll('.radios--root')[0];
    var colorUL = radiosRoot.querySelector('.radios--container');
    var radiosName = colorUL.getAttribute('aria-labelledby');
    var selectedRadio = colorUL.querySelector('.radios--input');
    var currentColor = selectedRadio.value;

    for (var i = 0; i < products.length; i++) {
      var prod = products[i];
      
      if (!('selectedColor' in prod) || prod.selectedColor == '') {
        continue;
      }

      if (prod.selectedColor == currentColor) {
        selectedRadio.parentElement.classList.add('selected');
        selectedRadio.parentElement.setAttribute('data-sort', i);
      } else {
        var prodSwatchUrl = prod.url;
        try {
          var temp = productTileHref.split('/');
          temp = temp.filter((str) => str !== '');        
          if (temp.indexOf('collections') > -1) {
            var productsIndex = temp.indexOf('products');          
            temp = temp.slice(0, productsIndex);            
            var temp2 = prod.url.split('/');
            temp2 = temp2.filter((str) => str !== '');  
            var urlarr = temp.concat(temp2);          
            var newurl = urlarr.join('/');            
            prodSwatchUrl = '/' + newurl;
          }
        } catch (ex) {}
        
        var radioId = radiosName + '-' + prod.selectedColor.toLowerCase().replace(' ', '');
        var newRadio = document.createElement('input');
        newRadio.type = 'radio';
        newRadio.classList.add('radios--input');
        newRadio.name = radiosName;
        newRadio.id = radioId;
        newRadio.disabled = true;
        newRadio.value = prod.selectedColor;
        newRadio.setAttribute('data-item', 'radio');
        
        var newLabel = document.createElement('label');
        newLabel.classList.add('radios--swatch-button');
        newLabel.setAttribute('for', radioId);
        newLabel.setAttribute('data-item', 'swatch');
        newLabel.setAttribute('aria-label', prod.selectedColor);
        newLabel.setAttribute('data-url', prodSwatchUrl);
        
        var newLI = document.createElement('div');
        newLI.classList.add('radios--main');
        newLI.setAttribute('data-sort', i);
        
        newLI.appendChild(newRadio);
        newLI.appendChild(newLabel);
        colorUL.appendChild(newLI);
      }
    }
    theme.utils.setSwatchColors(colorUL.querySelectorAll('input'));

    Array.from(colorUL.querySelectorAll('.radios--main')).sort(function(a, b) {
      return +a.dataset.sort - +b.dataset.sort;
    }).forEach(e => colorUL.appendChild(e));

    var swatchLabels = colorUL.querySelectorAll('.radios--swatch-button');
    for (var x = 0; x < swatchLabels.length; x++) {
      var swatchLabel = swatchLabels[x];
      swatchLabel.addEventListener('click', function (e) {
        if (this.parentElement.classList.contains('selected')) {
          window.location.href = productTileHref;
        } else {
          e.preventDefault();
          e.stopPropagation();
          var swatchHref = this.dataset['url'];
          if (swatchHref) {
            window.location.href = swatchHref;
          }                  
        }
      });      
    }
  }
}
const productTileSwatchesEl = customElements.get('product-tile-swatches-root')
productTileSwatchesEl || customElements.define('product-tile-swatches-root', ProductTileSwatches)
